import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { UtilitiesService } from '../../services/utilities.service';
import { filter, map, take } from 'rxjs';

export const isPartnerGuard: CanActivateFn = (route) => {
  const router = inject(Router);
  const utilities = inject(UtilitiesService);
  let activeRoute = route.url[route.url.length - 1]?.path;

 return utilities.isPartner$.pipe(
  filter((val): val is boolean => val !== null),
  take(1),
  map(isPartner => {

    const tryingToAccessClientDashboard = activeRoute === 'dashboard' && isPartner;
    const tryingToAccessPartnerDashboard = activeRoute === 'partner-dashboard' && !isPartner;
    if (tryingToAccessClientDashboard || tryingToAccessPartnerDashboard) {
      router.navigate(['select-client']);
      return false;
    }
    return true;
  })
);
};
